import React from 'react';
import sharedStyles from './ManagerShared.module.css';
import styles from './ManagerSeasonMomentum.module.css';

export default function ManagerSeasonMomentum({ momentum }) {
    if (!momentum) return null;

    const hasBigChances = momentum.bigChancesConceded !== '-' && Number(momentum.bigChancesConceded) !== 0;
    const hasErrors = momentum.errorsLeadingToGoals !== '-' && Number(momentum.errorsLeadingToGoals) !== 0;

    if (!hasBigChances && !hasErrors) return null;

    return (
        <section className={sharedStyles.section}>
            <h2 className={sharedStyles.sectionTitle}>Statistics</h2>
            <div className={styles.momentumGrid}>
                {hasBigChances && (
                    <div className={styles.statBox}>
                        <div className={styles.statValue}>{momentum.bigChancesConceded}</div>
                        <div className={styles.statLabel}>BIG CHANCES CONCEDED</div>
                    </div>
                )}
                {hasErrors && (
                    <div className={styles.statBox}>
                        <div className={styles.statValue}>{momentum.errorsLeadingToGoals}</div>
                        <div className={styles.statLabel}>ERRORS LEADING TO GOALS</div>
                    </div>
                )}
            </div>
        </section>
    );
}
